import { infer as Infer, z } from 'zod';

export const loginSchema = z.object({
  // Trim before validating: mobile keyboards append a space after an autocompleted address.
  email: z.string().trim().toLowerCase().pipe(z.email('Niepoprawny email')),
  password: z.string('Hasło jest wymagane').trim().min(1, 'Hasło jest wymagane'),
});

export type LoginSchema = Infer<typeof loginSchema>;
